// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const linoone: PokeData = {
  "id": 264,
  "name": "linoone",
  "height": 5,
  "weight": 325,
  "base_experience": 147,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "sand-attack",
    "headbutt",
    "tackle",
    "take-down",
    "double-edge",
    "tail-whip",
    "pin-missile",
    "growl",
    "fury-swipes",
    "rest",
    "slash",
    "flail",
    "belly-drum",
    "mud-sport",
    "odor-sleuth",
    "covet",
    "fling",
    "switcheroo",
    "hone-claws",
    "bestow",
    "rototiller",
    "play-rough",
    "baby-doll-eyes"
  ],
  "moves": [
    "headbutt",
    "tackle",
    "pin-missile",
    "growl",
    "rototiller",
    "play-rough",
    "purification",
    "quick-attack",
    "refresh",
    "supersonic",
    "leer",
    "protect",
    "scary-face"
  ],
  "evolution_chain": {
    "id": 134,
    "item": null,
    "species": [
      {
        "name": "zigzagoon",
        "order": 288,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "linoone",
        "order": 289,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 263,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "obstagoon",
        "order": 862,
        "types": [
          PokeType.DARK,
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 264,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 35,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "night",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 69.5,
    "speed": 100,
    "ability_power": 70
  },
  "stat_changes": [],
  "catch_rate": 90,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
